import { useState } from 'react'

import './_paymentMethod.scss'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import InputCard from 'components/Form/InputCard/InputCard'
import { addToast } from 'components/Toast/Toast'
import FixedBottomButton from 'components/UI/FixedBottomButton/FixedBottomButton'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { putPaxumInformation } from 'services/endpoints/settings/general/payout'
import { useAuthStore } from 'store'

import { Ach } from './ACH'
import { Wire } from './Wire'

export const PaymentList = ({ page }: { page: string }) => {
    const [paxumEmail, setPaxumEmail] = useState('')
    const { t } = useTranslation()

    const validateEmail = () => {
        return /\S+@\S+\.\S+/.test(paxumEmail) && paxumEmail.length > 0
    }

    const mutation = useMutation(
        async (formData: { paxum_email: string }) =>
            await putPaxumInformation(formData),
        {
            onSuccess: () => {
                useAuthStore.getState().setUserProfile({
                    payout_method: 'paxum'
                })
            },
            onError: error => {
                addToast(
                    'error',
                    t('error:anErrorOccuredPleaseTryAgain')
                )

                console.error('Error saving paxum email:', error)
            }
        }
    )

    const handleSubmit = () => {
        if (!validateEmail()) {
            addToast('error', 'Please enter a valid email address.')
            return
        }

        mutation.mutate({
            paxum_email: paxumEmail
        })
    }

    const renderHeader = (): JSX.Element => {
        switch (page) {
            case 'wire':
                return (
                    <LayoutHeader
                        type='basic'
                        section={t('bankInformation')}
                        title={t('wire')}
                    />
                )

            case 'ach':
                return (
                    <LayoutHeader
                        type='basic'
                        section={t('paymentMethod')}
                        title={t('ach')}
                    />
                )

            case 'paxum':
                return (
                    <LayoutHeader
                        type='basic'
                        section={t('paymentMethod')}
                        title={t('paxum')}
                    />
                )

            default:
                return (
                    <LayoutHeader
                        type='basic'
                        section={t('paymentMethod')}
                        title={t('paymentMethod')}
                    />
                )
        }
    }

    const renderPage = () => {
        switch (page) {
            case 'wire':
                return <Wire />

            case 'ach':
                return <Ach />

            case 'paxum':
                return (
                    <InputCard
                        type='text'
                        label={t('email')}
                        value={paxumEmail}
                        changeFn={(val: string) => {
                            setPaxumEmail(val)
                        }}
                        validate='email'
                    />
                )

            default:
                return null
        }
    }

    const renderBottomButton = () => {
        if (page !== 'paxum') {
            return null
        }

        return (
            <FixedBottomButton
                text={t('save')}
                disabled={!validateEmail() || mutation.isLoading}
                customClass='paymentMethod__fixedbottombtn'
                clickFn={handleSubmit}
            />
        )
    }

    return (
        <WithHeaderSection headerSection={renderHeader()}>
            <>
                {renderPage()}
                {renderBottomButton()}
            </>
        </WithHeaderSection>
    )
}